import { useState } from 'react';
import { IconButton } from '@heathmont/moon-core-tw';
import useNewThumbnailsEnabled from '~/client/hooks/feature/useNewThumbnailsEnabled';
import Translate from '~/client/shared/i18n/Translate';
import PageTitle from '~/client/shared/PageTitle';
import SubTitle from './SubTitle';
import GameFilters from '../../GameFilters';
import SoftwarePlate from '@/external/icons/SoftwarePlate';
import SoftwareSorting from '@/external/icons/SoftwareSorting';
import TextListView from '@/external/icons/TextListView';

type Props = {
  hasFilters: boolean;
  isGridVisible: boolean;
  pageSection: PageSection;
  pageTitle?: string;
  providerName?: string;
  isLiveRtp?: boolean;
  menuItem?: string;
  onShowGridClick: () => void;
  pageSubTitle?: string;
};

const MobileFirstRow: FC<Props> = ({
  isGridVisible,
  hasFilters,
  onShowGridClick,
  pageTitle,
  pageSection,
  providerName,
  isLiveRtp,
  menuItem,
  pageSubTitle,
}) => {
  const newThumbsEnabled = useNewThumbnailsEnabled();
  const [showFilters, setShowFilters] = useState(false);
  const handleFilterClick = () => setShowFilters((isVisible) => !isVisible);
  return (
    <div className="relative grid grid-cols-minmax gap-4 md:mb-2.5 lg:grid-flow-col lg:justify-between">
      <div className="grid grid-flow-col grid-cols-minmax gap-2 p-1">
        <div className="grid grid-cols-minmax gap-1">
          <PageTitle translateId={pageTitle ?? providerName} />
          {pageSubTitle && (
            <SubTitle>
              <Translate id={pageSubTitle} />
            </SubTitle>
          )}
        </div>
        {!newThumbsEnabled && (
          <IconButton
            size="xs"
            onClick={onShowGridClick}
            variant="tertiary"
            className="h-10 w-10 rounded-moon-i-xs text-moon-32 text-trunks"
          >
            {isGridVisible ? <SoftwarePlate /> : <TextListView />}
          </IconButton>
        )}
        {hasFilters && (
          <IconButton
            size="xs"
            onClick={handleFilterClick}
            variant="tertiary"
            className="h-10 w-10 rounded-moon-i-xs text-moon-32 text-bulma"
          >
            <SoftwareSorting />
          </IconButton>
        )}
      </div>
      {showFilters && (
        <GameFilters
          pageSection={pageSection}
          isLiveRtp={isLiveRtp}
          menuItem={menuItem}
          isProviderFilterVisible
        />
      )}
    </div>
  );
};

export default MobileFirstRow;
